module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mh4 mt4"
  }, [_c('div', {
    staticClass: "row w-100 middle-xs between-xs"
  }, [(_vm.users_tab === 'admin-add-users') ? _c('div', {
    staticClass: "add-users-title"
  }, [_vm._v("\n      Add users to your organization\n    ")]) : _c('div', {
    staticClass: "add-users-title"
  }, [_vm._v("Add courses to your organization")]), _vm._v(" "), (_vm.screenActive < 2) ? _c('pl-button', {
    class: _vm.nextStep ? 'pl-primary' : 'disabled',
    staticStyle: {
      "font-size": "16px",
      "font-weight": "550"
    },
    attrs: {
      "disabled": !_vm.nextStep
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextScreen.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      IMPORT\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row col-xs center-xs middle-xs"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-08da8f9a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalUsers/addUsers/addUsersStepsBar.vue
// module id = 2063
// module chunks = 61